import Base from "../../../../../class/Base";
import VProdshop from "../VProdshop";
import VShowcaseShop from "./VShowcaseShop"

export default class VShowcaseShopItem extends Base {}
VShowcaseShopItem.addProperties({
	vProdshop: VProdshop,
	vShowcaseShop: VShowcaseShop,
});
